import React from 'react'
import { Link } from 'react-router-dom'
import {Row,Col} from 'react-bootstrap'
import Card from '../../../components/Card'
import { useLanguage } from '../../../i18n/LanguageContext'

 const HeaderBread = () => {
     const { t } = useLanguage()

     return(
         <>
            <Row>
                <Col md="12">
                    <Card>
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div className="card-title mb-0">
                                <h4 className="mb-0">{t.nav.calendar}</h4>
                            </div>
                            <div className="card-action">
                                <Link to="/dashboard" className="btn btn-primary" role="button">{t.nav.dashboard}</Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}
export default HeaderBread
